import React from "react";
import "./ConsultingServices.css";

function ConsultingServices() {
  const consultingAreas = [
    {
      title: "Logistics Consulting",
      icon: "🚚",
      description: "Optimising supply chain operations for maximum efficiency",
      services: [
        "Supply Chain Optimisation",
        "Warehouse Management",
        "Transportation Planning",
        "Last-Mile Delivery Solutions",
        "Inventory Management",
        "Route Optimisation",
      ],
      stats: {
        reduction: "30%",
        metric: "Cost Reduction",
      },
    },
    {
      title: "Medical Supply Chain",
      icon: "🏥",
      description: "Ensuring reliable healthcare logistics and distribution",
      services: [
        "Pharmaceutical Distribution",
        "Cold Chain Management",
        "Medical Equipment Logistics",
        "Hospital Supply Management",
        "Regulatory Compliance",
        "Emergency Response Planning",
      ],
      stats: {
        reduction: "99.9%",
        metric: "Delivery Accuracy",
      },
    },
  ];

  return (
    <section id="consulting" className="consulting-services">
      <div className="container">
        <div className="section-title">
          <h2>Strategic Consulting Services</h2>
          <p>
            Expert guidance in logistics and medical supply chain management
          </p>
        </div>

        <div className="consulting-grid">
          {consultingAreas.map((area, index) => (
            <div key={index} className="consulting-card">
              <div className="card-header">
                <span className="card-icon">{area.icon}</span>
                <h3>{area.title}</h3>
              </div>
              <p className="card-description">{area.description}</p>

              <div className="services-list">
                <h4>Our Services Include:</h4>
                <ul>
                  {area.services.map((service, serviceIndex) => (
                    <li key={serviceIndex}>{service}</li>
                  ))}
                </ul>
              </div>

              <div className="stat-highlight">
                <div className="stat-number">{area.stats.reduction}</div>
                <div className="stat-label">{area.stats.metric}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="consulting-process">
          <h3>Our Consulting Process</h3>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">01</div>
              <h4>Assessment</h4>
              <p>Comprehensive analysis of your current operations</p>
            </div>
            <div className="process-connector"></div>
            <div className="process-step">
              <div className="step-number">02</div>
              <h4>Strategy</h4>
              <p>Customised solutions tailored to your needs</p>
            </div>
            <div className="process-connector"></div>
            <div className="process-step">
              <div className="step-number">03</div>
              <h4>Implementation</h4>
              <p>Seamless execution with minimal disruption</p>
            </div>
            <div className="process-connector"></div>
            <div className="process-step">
              <div className="step-number">04</div>
              <h4>Optimisation</h4>
              <p>Continuous improvement and support</p>
            </div>
          </div>
        </div>

        <div className="cta-section">
          <h3>Ready to Transform Your Supply Chain?</h3>
          <p>Let our experts help you achieve operational excellence</p>
          <a href="#contact" className="btn btn-primary">
            Schedule a Consultation
          </a>
        </div>
      </div>
    </section>
  );
}

export default ConsultingServices;
